import type { JSX } from 'react'
import type { IPopupComponentProps } from 'blocks/Popup'

import { PopupComponent } from 'blocks/Popup'
import { useClearPopup } from 'blocks/Popup/components/PINLock/handlers'
import { PopupPINLockHeader } from 'blocks/TextBlock/Templates'
import { useLockPageScroll } from 'utils/hooks'
import { COLOR } from 'vars/index'
import { PINCodeInput } from '../components/PINLock/PINCodeInput'
import { PINLockPopupWrapper } from '../PopupComponent.styled'

export interface IPINLockPopup extends Omit<
  IPopupComponentProps,
  'children' | 'skipKeyboardScrollIntoView' | 'skipKeyboardOverlayReposition'
> {
  title: string
  description: string
  invalid?: boolean
  disabled?: boolean
  errorMessage?: string
  onChangeInput?: (value: string) => void
  onCompleteInput?: (value: string) => void
}

export const PINLockPopup = ({
  title,
  description,
  invalid,
  disabled,
  errorMessage,
  onCompleteInput,
  onChangeInput,
  overlayColor = COLOR.SURFACE_OPACITY_DARK_70,
  ...rest
}: IPINLockPopup): JSX.Element => {
  const { inputRef } = useClearPopup({ invalid })

  useLockPageScroll()

  return (
    <PINLockPopupWrapper>
      <PopupComponent
        overlayColor={overlayColor}
        {...rest}
        skipKeyboardScrollIntoView
        skipKeyboardOverlayReposition
      >
        <PopupPINLockHeader title={title} description={description} />
        <PINCodeInput
          ref={inputRef}
          invalid={invalid}
          disabled={disabled}
          errorMessage={errorMessage}
          onComplete={onCompleteInput}
          onChange={onChangeInput}
        />
      </PopupComponent>
    </PINLockPopupWrapper>
  )
}
